import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "sanitize.css/sanitize.css";
import 'antd/dist/antd.css';

import reportWebVitals from "./reportWebVitals";
import History from "./services/History";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
// import {persistor, store} from './redux/store';
import {Provider} from "react-redux";
import axios from "axios";
import {App} from "app";
import {BrowserRouter} from "react-router-dom";
import store from './redux/store'
import appConfigService from "./services/AppConfigService";

interface Props {
    Component: typeof App;
}

// const store = configureAppStore();

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (!error.response) {
            error.response = {
                data: "Network error",
                status: 500,
            };
        }
        if (error.response.status === 401) {
            localStorage.clear();
            History.push("/auth/login");
            throw error;
        }
        return Promise.reject(error);
    }
);

// Load runtime config before rendering app
appConfigService.load().then(() => {
    // Suppress console.log in non-DEV environments
    if (process.env.REACT_APP_ENVIRONMENT !== 'DEV') {
        console.log = function () {};
    }

    // Set axios base URL from runtime config
    axios.defaults.baseURL = appConfigService.baseUrl;

    const root = ReactDOM.createRoot(
        document.getElementById("root") as HTMLElement
    );
    root.render(
        <Provider store={store}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </Provider>
    );

    reportWebVitals();
}).catch((error) => {
    console.error('Failed to initialize application:', error);
    const root = document.getElementById("root");
    if (root) {
        root.innerHTML = '<div style="text-align:center;padding:50px;color:#ff4d4f;">Không thể tải cấu hình ứng dụng. Vui lòng thử lại sau.</div>';
    }
});
